import React, { ReactNode, useState } from 'react';
import {
    CalloutContainer,
    CalloutHeadingContainer,
    CalloutBody,
    CalloutHeading,
    CalloutColor,
    DismissButton,
} from './styles';
import { CALLOUT_TYPE } from '~/constants';
import CloseIcon from '~/assets/icons/ontario-icon-close.svg';

export interface CallOutProps {
    calloutType: CALLOUT_TYPE;
    heading?: ReactNode | string | null;
    calloutColor?: CalloutColor;
    children?: ReactNode;
    className?: string;
    dismissible?: boolean;
    onDismiss?: () => void;
    dismissAriaLabel?: string;
}

function Callout({
    calloutType,
    className,
    heading,
    children,
    calloutColor,
    dismissible,
    onDismiss,
    dismissAriaLabel,
}: CallOutProps) {
    const [isDismissed, setIsDismissed] = useState(false);

    const handleDismiss = () => {
        setIsDismissed(true);
        if (onDismiss) {
            onDismiss();
        }
    };

    if (isDismissed) {
        return null;
    }

    return (
        <CalloutContainer
            className={className}
            $alertType={calloutType}
            $calloutColor={calloutColor}
        >
            {!!dismissible && (
                <DismissButton onClick={handleDismiss} aria-label={dismissAriaLabel || 'Dismiss'}>
                    <CloseIcon aria-hidden="true" focusable="false" />
                </DismissButton>
            )}
            <CalloutHeadingContainer $dismissible={dismissible}>
                {heading &&
                    (typeof heading === 'string' ? (
                        <CalloutHeading $styledAs="h4">{heading}</CalloutHeading>
                    ) : (
                        heading
                    ))}
            </CalloutHeadingContainer>
            <CalloutBody>{children}</CalloutBody>
        </CalloutContainer>
    );
}

export default Callout;
